export default {"src":"/_next/static/media/logo_fairprice_fairpriceshop.a8b2cf58.svg","height":32,"width":204,"blurWidth":0,"blurHeight":0};